export default __webpack_public_path__ + "static/media/cartoon-positive-sound.e25928f4.mp3";